__turbopack_context__.v({
  "button": "report-success-popup-module-scss-module__DNLK8a__button",
  "content": "report-success-popup-module-scss-module__DNLK8a__content",
  "content_wrapper": "report-success-popup-module-scss-module__DNLK8a__content_wrapper",
  "dialog_title": "report-success-popup-module-scss-module__DNLK8a__dialog_title",
  "header": "report-success-popup-module-scss-module__DNLK8a__header",
  "root": "report-success-popup-module-scss-module__DNLK8a__root",
  "text": "report-success-popup-module-scss-module__DNLK8a__text",
  "thank": "report-success-popup-module-scss-module__DNLK8a__thank",
});
